import { EPaletteModes } from '@/types/theme-packs.types';
import { LayoutGridState, EPanelDirections, EPreviewSize, defaultLayoutGrids } from './types';

export const initialState: LayoutGridState = {
  direction: EPanelDirections.LTR,
  panelOpen: true,
  oppositePanelOpen: false,
  footerOpen: false,
  pillarOpen: true,
  headerOpen: true,
  previewSize: EPreviewSize.DESKTOP,
  gridLayoutLTR: defaultLayoutGrids.ltr,
  gridLayoutRTL: defaultLayoutGrids.rtl,
  preFullScreenState: null,
  bodyAttributes: {
    theme: (document.body.getAttribute('data-admin-theme') || EPaletteModes.Dark) as EPaletteModes,
  },
};
